<script setup>
const props = defineProps({
  stats: {
    type : Array,
  },
  quantities : {
    type : Array,
  }
})
/*const stats = [
  { name: 'Actieve producten', stat: '10625' },
  { name: 'Recent geupdate producten', stat: '58.16%' },
  { name: 'Updates deze week', stat: '24.57%' },
  { name: 'Huidige Marge', stat: '24.57%' },
]*/
</script>

<template>
  <div v-if="true">
    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-4">
      <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">{{ quantities.activeProducts.name }}</dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
          {{ quantities.activeProducts.stat }}
          <span class="text-slate-500 text-lg">van {{ quantities.totalQuantity.stat }}</span>
        </dd>
      </div>
      <div v-for="item in stats" :key="item.name" class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
        <dt class="truncate text-sm font-medium text-gray-500">{{ item.name }}</dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{{ item.stat }}</dd>
      </div>
    </dl>
  </div>
</template>


